// 表单字段前端校验:Name / Email(UI-SPEC §4.4,D-18 "最小校验非空")
// T-01-04-04 防御:email 正则 [^\s@]+ 禁含空白字符,trim() 去首尾

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * 非空名字:trim 后长度 >= 1
 */
export function isValidName(name: string): boolean {
  return typeof name === 'string' && name.trim().length > 0;
}

/**
 * 合法 email:简化 RFC5322 正则,trim 后匹配;内部不能含空白
 */
export function isValidEmail(email: string): boolean {
  if (typeof email !== 'string') return false;
  return EMAIL_RE.test(email.trim());
}
